// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"33881897","853":"7d4a7024","935":"bd454bf6"}[chunkId] + ".chunk.css";
};